module.exports = __webpack_public_path__ + "static/img/iDual2@2x.972c85d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/iDual2@2x.jpg
// module id = 466
// module chunks = 0